<template>
  <div class="Info">
    <div class="container content_p">
      <div style="height: 0.25rem"></div>
      <div class="info">
        <div>
          <Chart>
            <div slot="tab">
              <div class="info_box">
                <el-form :model="form" :rules="rules" ref="form">
                  <el-row :gutter="20">
                    <el-col :span="8" :xs="{ span: 24 }">
                      <el-form-item label="上传头像：" prop="head_pic">
                        <div v-if="form.head_pic" class="headPic">
                          <img
                            :src="form.head_pic"
                            class=""
                            @click="onPreviewCert()"
                          />
                          <el-link
                            icon="el-icon-zoom-in"
                            @click="onPreviewCert()"
                            style="margin-right: 20px"
                            >查看</el-link
                          >
                          <el-link icon="el-icon-delete" @click="onRemoveCert()"
                            >删除</el-link
                          >
                        </div>

                        <el-upload
                          v-else
                          action="#"
                          class="avatar-uploader"
                          list-type="picture-card"
                          :file-list="avatarFileList"
                          :limit="1"
                          :http-request="uploadCert"
                          :before-upload="beforeUploadCert"
                          :on-remove="onRemoveCert"
                          :on-preview="onPreviewCert"
                          accept="image/*"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16" :xs="{ span: 24 }">
                      <el-row :gutter="20">
                        <el-col :span="12" :xs="{ span: 24 }">
                          <el-form-item prop="user_name" label="真实姓名：">
                            <el-input
                              placeholder="请输入您的真实姓名"
                              v-model="form.user_name"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12" :xs="{ span: 24 }">
                          <el-form-item prop="mobile" label="联系电话：">
                            <el-input
                              placeholder="请输入联系方式"
                              v-model="form.mobile"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="sex" label="性别">
                            <el-select
                              v-model="form.sex"
                              placeholder="请选择性别"
                              style="width: 100%"
                            >
                              <el-option
                                v-for="item in $common.sexList"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12" :xs="{ span: 12 }">
                          <el-form-item prop="birthday" label="出生日期：">
                            <el-date-picker
                              style="padding-right: 0"
                              placeholder="请输入出生日期"
                              v-model="form.birthday"
                              type="date"
                            ></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24" :xs="{ span: 24 }">
                          <el-form-item prop="address" label="现居住地：">
                            <el-input
                              placeholder="请输入现居住地"
                              v-model="form.address"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24" :xs="{ span: 24 }">
                          <el-form-item
                            prop="resume_file_path"
                            label="上传简历："
                          >
                            <el-upload
                              class="upload-demo"
                              action="#"
                              :on-preview="handlePreview"
                              :on-remove="handleRemove"
                              :before-remove="beforeRemove"
                              :before-upload="beforeUploadFile"
                              :on-exceed="handleExceed"
                              :http-request="uploadFileResume"
                              :file-list="fileList"
                              :limit="1"
                              accept="application/pdf,application/PDF"
                            >
                              <el-button
                                v-show="showUpLoad"
                                size="small"
                                type="primary"
                                >点击上传</el-button
                              >
                              <div
                                slot="tip"
                                v-show="showUpLoad"
                                class="el-upload__tip"
                              >
                                只能上传word/pdf文件！
                              </div>
                              <el-tag type="success" v-show="!showUpLoad"
                                >上传成功，如需修改，请先删除已上传文件！</el-tag
                              >
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="hold">
                <el-button type="success" plain @click="ClickHold('form')"
                  >保存</el-button
                >
              </div>
            </div>
          </Chart>
        </div>
      </div>
      <div style="height: 0.35rem"></div>
    </div>
    <el-dialog
      title="绑定用户"
      :visible.sync="setUserShow"
      width="50%"
      :xs="{ span: 18 }"
    >
      <el-form
        ref="mobileLoginForm"
        :model="mobileLoginForm"
        :rules="mobileRules"
        label-width="80px"
      >
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="mobileLoginForm.mobile" disabled></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="yzm">
          <el-input v-model="mobileLoginForm.yzm"
            ><el-button slot="append" icon="el-icon-message" @click="sendSmsbtn" :disabled="!showTime"
                    >{{count}}</el-button
            ></el-input
          >
        </el-form-item>
      </el-form>
      <div class="sub_dl">
        <el-button
          type="primary"
          icon="el-icon-user-solid"
          @click="toMobileLogin('bind')"
          >登录</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="图片预览" :visible.sync="showPic" width="80%">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Chart from "@/components/Chart.vue";
import LoginJs from "./mixins/login";
import { validateMobile } from "@/utils/regex";
export default {
  props: {},
  mixins: [LoginJs],
  data() {
    // 封装的检查手机格式的方法
    let checkphone = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!validateMobile(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error("请输入正确的手机号!"));
      } else {
        if (this.$store.state.user.loginType.key == "weChat") {
          this.checkMobile(value).then((res) => {
            const flag = res.content;
            if (flag == "error") {
              this.setUserShow = true; // 处理绑定流程；
              this.mobileLoginForm.mobile = this.form.mobile;
              callback(new Error("手机号已存在，请校验后完成绑定操作！"));
            } else {
              callback();
            }
          });
        } else {
          callback();
        }
      }
    };
    return {
      form: {},
      options: [
        {
          value: 0,
          label: "保密",
        },
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      rules: {
        user_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [{ required: true, validator: checkphone, trigger: "blur" }],
        sex_name: [
          { required: true, message: "至少选择一个", trigger: "blur" },
        ],
        birthday: [
          { required: true, message: "请选择您的出生日期", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入您的居住地址", trigger: "blur" },
        ],
      },
      setUserShow: false,

      avatarFileList: [],
      showPic: false,
      dialogImageUrl: "",

      // 文件上传
      fileList: [],
      showUpLoad: true,
    };
  },
  computed: {},
  created() {
    this.getInfo();
  },
  mounted() {},
  watch: {},
  methods: {
    // 保存后的点击事件
    ClickHold(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          // 用户信息保存上传
          // console.log("成功",this.form,);
          this.$http
            .post(this.$api.saveUserInfo, this.form, true)
            .then((res) => {
              console.log("成功");
              this.$message.success("保存成功！");
              this.$store.dispatch("user/getInfo").then(() => {
                this.$router.go(0);
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取用户信息
    getInfo() {
      this.form = { ...this.$store.getters.user };
      if (this.form.resume_file_path) {
        this.fileList.push({
          name: "附件.pdf",
          url: this.form.resume_file_path,
        });
        this.showUpLoad = false;
      }
      // 如果微信扫码不是首次登录 更新登录类型
      if (this.form.mobile) {
        this.$store.dispatch("user/setUserType", {
          key: "mobile",
          value: "微信扫码非首次登录",
        });
      }
      console.log("env:",process.env.VUE_APP_BASE_FILE_API);
    },
    // 验证手机号是否存在
    async checkMobile(e) {
      console.log("mobile input ", e);
      return await this.$http.post(this.$api.checkMobile, { mobile: e }, true);
    },
    // element
    // 上传图片处理
    beforeUploadCert(file) {
      this.fileData = new FormData();
      this.fileData.append("upload", file);
      this.fileData.append("dir", "headPic");
    },
    uploadCert() {
      this.$http
        .upload(this.$api.editorUploadImage, this.fileData)
        .then((res) => {
          let fileContent = res.content;
          this.form.head_pic =
            process.env.VUE_APP_BASE_FILE_API + fileContent.url;
          this.$success("上传成功");
        });
    },
    onPreviewCert() {
      this.dialogImageUrl = this.form.head_pic;
      this.showPic = true;
    },
    onRemoveCert() {
      this.avatarFileList = [];
      this.form.head_pic = null;
      // this.$store.dispatch("user/getInfo").then(() => {
      //   this.getInfo();
      // });
    },
    // 上传文件
    beforeUploadFile(file) {
      this.resumeFileData = new FormData();
      this.resumeFileData.append("upload", file);
      this.resumeFileData.append("dir", "uploadResume");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.showUpLoad = true;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {      
      this.showUpLoad = true;
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    uploadFileResume() {
      this.$http
        .upload(this.$api.UploadFileResume, this.resumeFileData)
        .then((res) => {
          let fileContent = res.content;
          this.form.resume_file_path =  process.env.VUE_APP_BASE_FILE_API + fileContent.url;
          this.$success("上传成功");
          this.showUpLoad = true;
        });
    },
  },
  components: {
    Chart,
  },
};
</script>

<style lang="less" scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}
.headPic {
  line-height: 24px;
  text-align: center;
}
.info_box {
  margin: 0.2rem 0;
  display: flex;

  img {
    width: 100%;
    height: 100%;
  }

  .text {
    flex: 4;
    padding: 0 0.2rem;
    .form_box {
      display: flex;
      flex-wrap: wrap;
      .form_item {
        width: 50%;
        padding: 0 0.13rem;
        .el-input {
          width: 100%;
        }
      }
      .w1 {
        width: 100%;
      }
    }
  }
}
.hold {
  margin-left: 50%;
  transform: translateX(-50%);
  width: 2.1rem;
  height: 0.48rem;
  button {
    width: 100%;
    height: 100%;
    padding: 0;
    font-size: 0.14rem;
  }
}
@media only screen and (max-width: 766px) {
  .info_box {
    flex-direction: column;
    align-items: center;
    max-width: 96vw;
    margin: 0 auto;
    .img {
      margin-bottom: 0.2rem;
    }
    .text {
      .form_box {
        .form_item {
          width: 100%;
        }
      }
    }
  }
  .hold {
    width: 4rem;
    height: 0.68rem;
    button {
      font-size: 0.24rem;
    }
  }
}
</style>
